const pieColors = [
	'#ffd91f', '#921fff',
	'#6deb4f', '#f71fff',
	'#4aeac2', '#ff1fb3',
	'#9dc3ff', '#dc006b',
	'#1fcaff', '#ff1f1f',
	'#4851e1', '#ff711f',
	'#1f2cff', '#ffac14'
]

export default pieColors
